<!-- svelte-ignore a11y-click-events-have-key-events -->
<script>
	import { TwitchIcon, VideoIcon, ChevronDownIcon, ChevronRightIcon, MailIcon } from 'svelte-feather-icons'
	import { faDiscord } from '@fortawesome/fontawesome-free-brands';
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	var emailInfo = {
		name: '',
		email: '',
		subject: '',
		body: ''
	};

	onMount(() => {
		console.log($io)
		window.io = $io;
	});

	function sendEmail(){
		$io.serve("send_email", emailInfo, function(){
			alert('Message Sent!');
			emailInfo = {
				name: '',
				email: '',
				subject: '',
				body: ''
			};
		});
	}
	
</script>

<div class='con-page'>
	<div class='con-dash'>
		
		<div class='landing-header y'>
			Contact
		</div>

		<div style='display:grid; width:100%;'>
			<div class='landing-header-s y'>
				Contact Us
			</div>

			<div class='con-field'>
				<div>Name</div>
				<div>
					<input bind:value={emailInfo.name} />
				</div>
			</div>

			<div class='con-field'>
				<div>Email</div>
				<div>
					<input bind:value={emailInfo.email} />
				</div>
			</div>

			<div class='con-field'>
				<div>Message</div>
				<div>
					<textarea bind:value={emailInfo.body} />
				</div>
			</div>

			<div class='btn btn-send' on:click={()=>{ sendEmail(); }}> 
				<MailIcon /> <div>Send</div> 
			</div>

		</div>

		<hr />

		<div>
			<div class='landing-header-s y'>
				Discord Support Channel
			</div>
			<p>
				Check out our Discord for FGCard Bot related questions, bugs or concerns.
			</p>
			<div on:click={()=>{ window.location.href = "https://discord.gg/K6aFgkGe"; }} class='btn btn-send' style='width:200px; line-height:30px;'>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-discord" viewBox="0 0 16 16">
					<path d="M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612"/>
				  </svg>
				<div>Send A Message</div>
			</div>
		</div>



		<hr />

	</div>
</div>

<style type="text/less">

	hr{
		margin:30px 0;
	}

	p{
		color:rgba(255, 255, 255, 0.904);
		margin:15px;
		font-weight:500;
	}

	.btn-send{
		margin:10px;
		align-items:center;
		gap:10px;
		border-radius:8px;
		background-color:#f6ff00f1;
		color:black;
		width:100px;
	}

	.con-field{
		margin:10px;
		color:rgba(255, 255, 255, 0.822);

		:first-child{
			margin:3px;
		}

		input, textarea{

			background-color:black;
			color:rgba(255, 255, 255, 0.842);
			border:1px solid rgba(255, 255, 255, 0.212);
			width:100%;
		}
	}

	.con-page{
		display:grid;
	}
	.con-dash{
		display:grid;
		justify-self:center;
		width: 100%;
		max-width:var(--mwidth);
		//margin-top:30px;
		margin-top:10px;
		padding:30px;
	}

	.landing-header-s{
		font-weight:bold;
		font-size:1.5em;
	}

	.landing-header{
		text-align:center;
		font-weight:bold;
		font-size:3em;
	}

</style>